import React from 'react';
import { publish, subscribe, unsubscribe } from '@wh/message-bus';
import pick from 'lodash/pick';
import {
  RADIO_MARQUEE_ANIMATION_START,
  RADIO_MUTE_TOGGLE,
  RADIO_PAUSE_CLICKED,
  RADIO_PLAY_CLICKED,
  RADIO_STATE_UPDATED,
} from '../../topics';

export const ANIMATION_DELAY = 3000;
export const WH_RADIO_TYPE_RADIO = 'radio';
export const WH_RADIO_TYPE_LINK = 'link';

const withRadio = (WrappedComponent, componentProps = {}) => {
  class RadioWrapper extends React.Component {
    state = {
      animationOn: false,
      marqueeText: '',
      muted: false,
      playing: false,
      playingLabel: '',
    };

    componentDidMount() {
      this.subscribeStateUpdate = subscribe({
        topic: RADIO_STATE_UPDATED,
        callback: this.stateUpdate,
      });
    }

    componentWillUnmount() {
      if (this.subscribeStateUpdate) {
        unsubscribe(this.subscribeStateUpdate);
      }
      clearTimeout(this.textAnimationTimeout);
    }

    onPlayRequested = (data) => {
      publish({ topic: RADIO_PLAY_CLICKED, data });
      this.animateMarqueeText();
    };

    onPauseRequested = () => {
      publish({ topic: RADIO_PAUSE_CLICKED });
    };

    onMuteToggle = () => {
      publish({ topic: RADIO_MUTE_TOGGLE });
    };

    onClickHandler = (radioProps) => (e) => {
      const isCalledFromEqualizer = e.target.classList.contains('equalizer');

      if (!isCalledFromEqualizer && radioProps.type === WH_RADIO_TYPE_RADIO) {
        radioProps.label === this.state.playingLabel ? this.onPauseRequested() : this.onPlayRequested(radioProps);
      } else if (radioProps.type === WH_RADIO_TYPE_LINK) {
        window.open(radioProps.link, radioProps.target);
      }
    };

    animateMarqueeText = () => {
      if (!componentProps.isNested && !this.state.animationOn && this.state.marqueeText) {
        clearTimeout(this.textAnimationTimeout);

        this.textAnimationTimeout = setTimeout(() => {
          this.setState({ animationOn: true });
          publish({ topic: RADIO_MARQUEE_ANIMATION_START });
        }, ANIMATION_DELAY);
      }
    };

    stateUpdate = ({ data = {} } = {}) => {
      const newState = pick(data, Object.keys(this.state));
      this.setState(newState, () => {
        if (!componentProps.isNested) {
          this.animateMarqueeText();
        }
      });
    };

    render() {
      const { children, ...restProps } = componentProps;
      const props = {
        ...restProps,
        ...this.state,
        key: componentProps.forwardedKey,
        onPlayRequested: this.onPlayRequested,
        onPauseRequested: this.onPauseRequested,
        onMuteToggle: this.onMuteToggle,
        onClickHandler: this.onClickHandler,
        stateUpdate: this.stateUpdate,
        animateMarqueeText: this.animateMarqueeText,
      };
      if (children) {
        return <WrappedComponent {...props}>{children}</WrappedComponent>;
      }
      return <WrappedComponent {...props} />;
    }
  }

  return RadioWrapper;
};

export default withRadio;
